import { SlaCurrentStatusReadOnly, SlaEscalationStatus } from '@askporter/client-grieg-lyric';
import { IconFolder } from '../types';

export const slaIcons: Record<string, IconFolder> = {
  [SlaCurrentStatusReadOnly.Running]: 'tasks/task-list/task-card-sla/sla-running',
  [SlaCurrentStatusReadOnly.Paused]: 'tasks/task-list/task-card-sla/sla-paused',
  [SlaCurrentStatusReadOnly.CompletedOnTime]: 'tasks/task-list/task-card-sla/sla-completed',
  [SlaCurrentStatusReadOnly.CompletedLate]: 'tasks/task-list/task-card-sla/sla-completed-late',
  [SlaCurrentStatusReadOnly.Overdue]: 'tasks/task-list/task-card-sla/sla-overdue',
};

export const escalationIcons: Record<string, IconFolder> = {
  [SlaEscalationStatus.L1]: 'tasks/task-list/escalation/status-l1',
  [SlaEscalationStatus.L2]: 'tasks/task-list/escalation/status-l2',
  [SlaEscalationStatus.DoneL1]: 'tasks/task-list/escalation/status-done-l1',
  [SlaEscalationStatus.DoneL2]: 'tasks/task-list/escalation/status-done-l2',
};
